export const VIDEO_REQUEST_OCCASION_ID = ['VIDEO_REQUEST', 'requestOccasionId']
export const VIDEO_REQUEST_CUSTOM_REQUEST_OCCASION = [
  'VIDEO_REQUEST',
  'customRequestOccasion',
]
export const VIDEO_REQUEST_USAGE_OCCASION_IDS = [
  'VIDEO_REQUEST',
  'usageOccasionIds',
]
export const VIDEO_REQUEST_INSTRUCTIONS = ['VIDEO_REQUEST', 'instructions']
export const VIDEO_REQUEST_TO_NAME = ['VIDEO_REQUEST', 'toName']
export const VIDEO_REQUEST_FROM_NAME = ['VIDEO_REQUEST', 'fromName']
export const VIDEO_REQUEST_IS_GIFT = ['VIDEO_REQUEST', 'isGift']
export const VIDEO_REQUEST_FROM_PRONOUN = ['VIDEO_REQUEST', 'fromPronoun']
export const VIDEO_REQUEST_TO_PRONOUN = ['VIDEO_REQUEST', 'toPronoun']
export const VIDEO_REQUEST_PRIVATE = ['VIDEO_REQUEST', 'videoPrivateByCustomer']
